import { render } from "./AboutHolePage.vue?vue&type=template&id=2cd69a21"
import script from "./AboutHolePage.vue?vue&type=script&lang=js"
export * from "./AboutHolePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__